// --- Humanoid robot silhouette ---
export const ROBOT_EDGES = [
  // Head
  [0, 0.92, 0.08, 0.92], [0.08, 0.92, 0.12, 0.85], [0.12, 0.85, 0.12, 0.75],
  [0.12, 0.75, 0.08, 0.68], [0.08, 0.68, 0, 0.65], [0, 0.65, -0.08, 0.68],
  [-0.08, 0.68, -0.12, 0.75], [-0.12, 0.75, -0.12, 0.85], [-0.12, 0.85, -0.08, 0.92],
  [0, 0.65, 0, 0.56],
  [-0.38, 0.56, 0.38, 0.56],
  [-0.22, 0.56, -0.18, -0.05], [0.22, 0.56, 0.18, -0.05],
  [-0.18, -0.05, 0.18, -0.05],
  [-0.38, 0.50, -0.42, 0.15], [0.38, 0.50, 0.42, 0.15],
  [-0.42, 0.15, -0.38, -0.15], [0.42, 0.15, 0.38, -0.15],
  [-0.38, -0.15, -0.40, -0.25], [0.38, -0.15, 0.40, -0.25],
  [-0.12, -0.05, -0.10, -0.45], [0.12, -0.05, 0.10, -0.45],
  [-0.10, -0.45, -0.08, -0.78], [0.10, -0.45, 0.08, -0.78],
  [-0.08, -0.78, -0.14, -0.82], [-0.14, -0.82, 0.14, -0.82],
  [0.14, -0.82, 0.08, -0.78],
];

// --- Supply-chain node graph ---
const HUBS = [
  [0, 0.8], [-0.5, 0.5], [0.5, 0.5], [-0.7, 0], [0.7, 0],
  [-0.4, -0.4], [0.4, -0.4], [0, -0.6], [-0.15, 0.2], [0.15, 0.2],
];
const HUB_RADIUS = 0.08;
export const GRAPH_EDGES = [];
for (const [cx, cy] of HUBS) {
  for (let a = 0; a < 12; a++) {
    const t1 = (a / 12) * Math.PI * 2;
    const t2 = ((a + 1) / 12) * Math.PI * 2;
    GRAPH_EDGES.push([
      cx + Math.cos(t1) * HUB_RADIUS, cy + Math.sin(t1) * HUB_RADIUS,
      cx + Math.cos(t2) * HUB_RADIUS, cy + Math.sin(t2) * HUB_RADIUS,
    ]);
  }
}
const LINKS = [[0,1],[0,2],[0,3],[0,4],[1,3],[2,4],[3,5],[4,6],[5,6],[5,7],[6,7],[1,5],[2,6],[0,8],[0,9],[8,1],[9,2],[8,5],[9,6],[3,7],[4,7]];
for (const [a, b] of LINKS) {
  GRAPH_EDGES.push([HUBS[a][0], HUBS[a][1], HUBS[b][0], HUBS[b][1]]);
}

// --- Bay Area map ---
const MAP_COAST = [[-0.85, 0.70], [-0.82, 0.55], [-0.80, 0.40], [-0.78, 0.25], [-0.75, 0.10], [-0.72, -0.05], [-0.68, -0.20], [-0.62, -0.38], [-0.55, -0.55], [-0.45, -0.70], [-0.35, -0.82]];
const EAST_BAY = [[-0.35, -0.82], [-0.28, -0.75], [-0.20, -0.65], [-0.12, -0.50], [-0.05, -0.35], [0.05, -0.18], [0.12, 0.0], [0.18, 0.18], [0.22, 0.35], [0.15, 0.50]];
export const MAP_EDGES = [];
for (let i = 0; i < MAP_COAST.length - 1; i++) MAP_EDGES.push([...MAP_COAST[i], ...MAP_COAST[i + 1]]);
for (let i = 0; i < EAST_BAY.length - 1; i++) MAP_EDGES.push([...EAST_BAY[i], ...EAST_BAY[i + 1]]);

// --- Opportunity constellation (12 nodes = 12 opportunities) ---
export const CONSTELLATION_EDGES = [];
const OPP_NODES = [
  [0.15, 0.92, 0.10], [0.45, 0.85, 0.08], [0.72, 0.78, 0.06],
  [0.10, 0.55, 0.09], [0.38, 0.50, 0.07], [0.65, 0.45, 0.05],
  [0.20, 0.22, 0.08], [0.50, 0.18, 0.06], [0.80, 0.12, 0.05],
  [0.35, -0.05, 0.07], [0.68, -0.12, 0.05], [0.88, -0.20, 0.04],
];
for (const [cx, cy, r] of OPP_NODES) {
  for (let a = 0; a < 10; a++) {
    const t1 = (a / 10) * Math.PI * 2;
    const t2 = ((a + 1) / 10) * Math.PI * 2;
    CONSTELLATION_EDGES.push([
      cx + Math.cos(t1) * r, cy + Math.sin(t1) * r,
      cx + Math.cos(t2) * r, cy + Math.sin(t2) * r,
    ]);
  }
}
// Connect nodes with light trails
const TRAILS = [[0,1],[1,2],[0,3],[3,4],[4,5],[1,4],[2,5],[3,6],[6,7],[7,8],[4,7],[5,8],[6,9],[9,10],[10,11],[7,10],[8,11]];
for (const [a, b] of TRAILS) {
  CONSTELLATION_EDGES.push([OPP_NODES[a][0], OPP_NODES[a][1], OPP_NODES[b][0], OPP_NODES[b][1]]);
}

// --- Idle spiral ---
export const SPIRAL_EDGES = [];
for (let a = 0; a < 60; a++) {
  const t1 = a / 60 * Math.PI * 6;
  const t2 = (a + 1) / 60 * Math.PI * 6;
  const r1 = 0.1 + t1 * 0.04;
  const r2 = 0.1 + t2 * 0.04;
  SPIRAL_EDGES.push([
    Math.cos(t1) * r1, Math.sin(t1) * r1 * 0.6,
    Math.cos(t2) * r2, Math.sin(t2) * r2 * 0.6,
  ]);
}

// --- BOM bar chart — 6 bars = 6 subsystems, width = China-dependence ---
// Each bar: y position, bar length, color intensity (red→gold→green)
export const BOM_BARS = [
  { name: 'Actuators',        y: 0.55, length: 0.90, dep: 0.85 },  // 85% High
  { name: 'Hands',            y: 0.35, length: 0.55, dep: 0.45 },  // 45% Med
  { name: 'Power',            y: 0.15, length: 0.70, dep: 0.65 },  // 65% Med-High
  { name: 'Compute / Elec',   y: -0.05, length: 0.82, dep: 0.75 }, // 75% High
  { name: 'Sensors',          y: -0.25, length: 0.48, dep: 0.40 }, // 40% Med
  { name: 'Structure / Body', y: -0.45, length: 0.78, dep: 0.70 }, // 70% High
];

export const BOM_EDGES = [];
const BOM_X = -0.55;
for (const bar of BOM_BARS) {
  BOM_EDGES.push([BOM_X, bar.y, BOM_X + bar.length, bar.y]);
}

// Utility: sample edges into N point positions
export function edgesToPoints(edges, count, jitter = 0.015) {
  let totalLen = 0;
  const lengths = edges.map(([x1, y1, x2, y2]) => {
    const l = Math.hypot(x2 - x1, y2 - y1);
    totalLen += l;
    return l;
  });

  const out = new Float32Array(count * 2);
  let cursor = 0;

  for (let i = 0; i < count; i++) {
    let t = i / count;
    t = (t + (Math.random() - 0.5) * 0.2 / edges.length + 1) % 1;

    let target = t * totalLen;
    for (let j = 0; j < edges.length; j++) {
      if (target <= lengths[j]) {
        const frac = lengths[j] > 0 ? target / lengths[j] : 0;
        const [x1, y1, x2, y2] = edges[j];
        const x = x1 + (x2 - x1) * frac + (Math.random() - 0.5) * jitter;
        const y = y1 + (y2 - y1) * frac + (Math.random() - 0.5) * jitter;
        out[cursor++] = x;
        out[cursor++] = y;
        break;
      }
      target -= lengths[j];
    }
    if (cursor < (i + 1) * 2) {
      const last = edges[edges.length - 1];
      out[cursor++] = last[2] + (Math.random() - 0.5) * jitter;
      out[cursor++] = last[3] + (Math.random() - 0.5) * jitter;
    }
  }

  return out;
}

// Utility: make a color for each particle based on BOM bar assignment
// Returns Float32Array(count * 3) — RGB
export function bomBarColors(count) {
  const out = new Float32Array(count * 3);
  const barTotalLen = BOM_BARS.reduce((s, b) => s + b.length, 0);
  const barParticles = BOM_BARS.map(b => Math.round(b.length / barTotalLen * count));

  let cursor = 0;
  for (let b = 0; b < BOM_BARS.length; b++) {
    const num = barParticles[b];
    const dep = BOM_BARS[b].dep;
    // High dep = warm/red, Low dep = cool/green
    const r = dep * 0.7 + 0.25;
    const g = (1 - dep) * 0.45 + 0.30;
    const bl = (1 - dep) * 0.35 + 0.45;
    for (let i = 0; i < num && cursor < count; i++, cursor++) {
      out[cursor * 3] = r + (Math.random() - 0.5) * 0.12;
      out[cursor * 3 + 1] = g + (Math.random() - 0.5) * 0.12;
      out[cursor * 3 + 2] = bl + (Math.random() - 0.5) * 0.12;
    }
  }
  return out;
}
